import ApiService from '../api.service'
import DefaultHandlers from '../defaultHandlers.service';

const AutenticacaoService = {
    api: new ApiService(process.env.VUE_APP_URL_API + "/auth", () => DefaultHandlers.success(true), (error) => DefaultHandlers.failure(error)),

    echo: async function() {
        return await this.api.get("/echo").data;
    },

    autenticar: async function(login, senha) {
        const response = this.api.basicAuth("/", login, senha).then((response) => {
            if (response == undefined || response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Falha ao fazer o login do usuário sistêmico.",
                    token: null
                }
            }

            return {
                sucesso: true,
                mensagem: response.data.mensagem,
                token: {
                    token: response.data.token,
                    expiracao: response.data.expiracao,
                    tempoRenovacaoToken: response.data.tempoRenovacaoToken
                }
            }
        });

        return response;
    }
}

export default AutenticacaoService